import * as React from "react";

import useAuth from "../../hooks/useAuth";

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }) {
  const {
    isAuthenticated,
    isInitialized,
    isLoading,
    login,
    user,
    userError,
    logout,
  } = useAuth();

  React.useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      login(window.location.pathname);
    }
  }, [isInitialized, isAuthenticated, login]);

  if (!isInitialized || isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  // Handle case where OIDC auth succeeded but Django user fetch failed
  if (userError) {
    const isAuthError =
      userError.response?.status === 401 || userError.response?.status === 403;

    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Authentication Error</h2>
        <p>
          {isAuthError
            ? "Your session could not be verified. Please sign in again."
            : "Unable to load your account information. Please try again."}
        </p>
        <button
          onClick={() => {
            logout("/");
          }}
          style={{
            padding: "10px 20px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          Sign Out and Try Again
        </button>
      </div>
    );
  }

  if (!user) {
    return <div>Loading user data...</div>;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default AuthGuard;
